import { z } from 'zod';
import { BaseEventSchema } from '../Base';

export const ClickLoginEventSchema = BaseEventSchema.extend({
  location: z.enum(['navbar', 'home', 'menu']),
});

export const LoginContactWrittenEventSchema = BaseEventSchema.extend({
  type: z.enum(['phone', 'email']),
});

export const VerificationCodeEventSchema = BaseEventSchema.extend({
  type: z.enum(['phone', 'email']),
  code: z.string(),
});

export enum LoginInteractionEventTypes {
  ClickLogin = 'interaction.session.click_login',
  LoginContactWritten = 'interaction.session.login_input_written',
  LoginVerificationCodeWritten = 'interaction.session.verification_code_written',
  LoginResendCode = 'interaction.session.resend_verification_code',
  ClickLogout = 'interaction.session.click_logout',
  ClickConfirmLogout = 'interaction.session.click_confirm_logout',
  ClickModifyContact = 'interaction.session.click_modify_contact',
  TryAlternativeContact = 'interaction.session.try_alternative_contact',
  UseOtherContact = 'interaction.session.user_other_contact',
  SendCodeDuplicatedContact = 'interaction.session.send_code_duplicated_contact',
}

export const LoginInteractionEventTrackingSchemas = {
  [LoginInteractionEventTypes.ClickLogin]: ClickLoginEventSchema,
  [LoginInteractionEventTypes.LoginContactWritten]:
    LoginContactWrittenEventSchema,
  [LoginInteractionEventTypes.LoginVerificationCodeWritten]:
    VerificationCodeEventSchema,
  [LoginInteractionEventTypes.LoginResendCode]: BaseEventSchema,
  [LoginInteractionEventTypes.ClickLogout]: BaseEventSchema,
  [LoginInteractionEventTypes.ClickConfirmLogout]: BaseEventSchema,
  [LoginInteractionEventTypes.ClickModifyContact]:
    LoginContactWrittenEventSchema,
  [LoginInteractionEventTypes.TryAlternativeContact]:
    LoginContactWrittenEventSchema,
  [LoginInteractionEventTypes.UseOtherContact]: LoginContactWrittenEventSchema,
  [LoginInteractionEventTypes.SendCodeDuplicatedContact]:
    LoginContactWrittenEventSchema,
};
